import React, { FC } from 'react';
import { Button, Checkbox, ClickAwayListener, Grid, Grow, List, ListItem, ListItemIcon, ListItemText, Paper, Popper } from '@material-ui/core';
import { useStyles } from './styles';
import { CheckboxIcon, MoreIcon } from '../../CustomIcons';

interface Props {
  translation: any;
  reportColumns: string[];
  selectedColumns: string[];
  handleSelectColumns: (selectedColumns: string[]) => void;
}

export const ColumnsSelect: FC<Props> = ({ reportColumns, translation, selectedColumns, handleSelectColumns }) => {
  const classes = useStyles();
  const isAllSelected = reportColumns.length > 0 && selectedColumns.length === reportColumns.length;
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleToggle = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectChange = (option: string) => {
    const selected = [];
    if (option === 'all') {
      handleSelectColumns(selectedColumns.length === reportColumns.length ? [] : reportColumns);
    } else {
      if (selectedColumns.indexOf(option) > -1) {
        selected.push(...selectedColumns.filter((item) => item !== option));
      } else {
        selected.push(option, ...selectedColumns);
      }

      handleSelectColumns(selected);
    }
  };

  return (
    <Grid>
      <Button className={classes.btn} aria-describedby={id} onClick={handleToggle}>
        <MoreIcon />
      </Button>
      <Popper open={open} anchorEl={anchorEl} transition disablePortal style={{ zIndex: 6000 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <List dense>
                  <ListItem key="All" dense button onClick={() => handleSelectChange('all')}>
                    <ListItemIcon>
                      <Checkbox checked={isAllSelected} checkedIcon={<CheckboxIcon />} indeterminate={selectedColumns.length > 0 && selectedColumns.length < reportColumns.length} size="small" />
                    </ListItemIcon>
                    <ListItemText className={classes.selectText} primary={translation.text_1494} />
                  </ListItem>
                  {reportColumns.map((option) => (
                    <ListItem key={option} dense button onClick={() => handleSelectChange(option)}>
                      <ListItemIcon>
                        <Checkbox checkedIcon={<CheckboxIcon />} checked={selectedColumns.indexOf(option) > -1} size="small" />
                      </ListItemIcon>
                      <ListItemText className={classes.selectText} primary={option} />
                    </ListItem>
                  ))}
                </List>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Grid>
  );
};
